(() => {
  class RxhistoryController {
    constructor($rootScope, $interval, $scope, $timeout, $log, $window, $state, toastr, Auth, ngDialog, Orders, Notifications, Utils, Constants, $sce) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        $scope,
        $timeout,
        $log,
        $window,
        $state,
        $interval,
        toastr,
        ngDialog,
        Orders,
        Notifications,
        Utils,
        Constants,
        $sce,
        currentUser: Auth.profile,
        pageSize: 100
      });

      $scope.$on('tab:selected:rxhistory', (event, refreshInfo = true) => {
        this.init.bind(this);
        this.init(refreshInfo);
      });
    }

    $onInit() {
      this.init(false); // $scope.$on('tab:selected:rxhistory', this.init.bind(this));
    }

    init(refreshInfo = true) {
      this.rxHistory = [];
      this.pagination = {
        limit: this.pageSize,
        offset: -this.pageSize,
        // sort: 'created',
        sort: 'date_written',
        order: 'desc',
        total: 0
      };

      if (refreshInfo) {
        this.loadRxHistory();
        this.$rootScope.$broadcast('allergies:refresh');
      }
    }

    sort() {
      this.rxHistory = [];
      this.pagination.limit = this.pageSize;
      this.pagination.offset = -this.pageSize;
      this.loadRxHistory();
    }

    hasMoreHistory() {
      return this.loading || this.rxHistory.length < this.pagination.total;
    }

    loadRxHistory() {
      this.loading = true;
      this.pagination.offset += this.pagination.limit;
      this.Orders.getRxHistory(this.visit.user.id, this.pagination).then(({
        data
      }) => {
        const {
          data: rxHistory,
          pagination
        } = data;
        this.rxHistory = this.rxHistory.concat(rxHistory);
        Object.assign(this.pagination, pagination);
      }).catch(err => {
        console.log(err);
        this.rxHistory = [];
      }).finally(() => {
        this.loading = false;
      });
    }

  }

  RxhistoryController.$inject = ["$rootScope", "$interval", "$scope", "$timeout", "$log", "$window", "$state", "toastr", "Auth", "ngDialog", "Orders", "Notifications", "Utils", "Constants", "$sce"];
  angular.module('pims').component('visitRxhistory', {
    templateUrl: 'app/views/visits/detail/sections/rxhistory/rxhistory.html',
    controller: RxhistoryController,
    bindings: {
      visit: '=',
      parent: '=',
      patient: '='
    }
  });
})();
